import React, { useEffect, useState } from "react";
import E_Alerts_Card from "./view/_card";
import { Grid } from "@material-ui/core";
import moment from "moment";
import { meterAlertsCall } from "./model/e_meter_alert_service";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

export default function E_Alerts_Notification_Body({ noContent, childWidget, noContentContentReady }) {
  let [allData, setData] = useState([]);
  let [finalData, setFinalData] = useState();
  let [loading, setLoading] = useState(false);
  let [meterRank, setMeterRank] = useState();
  let [billRank, setBillRank] = useState();
  let [announceRank, setAnnRank] = useState();
  let [chargeRank, setChargeRank] = useState();
  let [minBalanceRank, setMinBalanceRank] = useState();
  let [lowBalaceRank, setLowBalanceRank] = useState();
  let [annLoad,setAnnLoad] = useState(false)
  let [meterLoad,setMeterLoad] = useState(false)
  let backendDataFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
  );
  let [startDate, setStartDate] = useState();
  let [endDate, setEndDate] = useState();
  let [announcementEndDate, setAnnouncementEndDate] = useState();
  
  useEffect(() => {
    if (childWidget) {
      childWidget.map((i) => {
        if (
          i.widgetCode === "E_METER_ALERTS" &&
          i.widgetDefaultValue === "true"
        ) {
          setMeterRank(i.widgetRank);
        } else if (
          i.widgetCode === "E_BILL_NOTIFICATION" &&
          i.widgetDefaultValue === "true"
        ) {
          setBillRank(i.widgetRank);
          i.children.map((childItem) => {
            if (
              childItem.widgetCode === "E_LOW_BALANCE" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setLowBalanceRank(childItem.widgetRank);
            } else if (
              childItem.widgetCode === "E_AMOUNT_CHARGE" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setChargeRank(childItem.widgetRank);
            } else if (
              childItem.widgetCode === "E_BELOW_MIN_BALANCE" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setMinBalanceRank(childItem.widgetRank);
            }
          });
        } else if (
          i.widgetCode === "E_ANNOUNCEMENT" &&
          i.widgetDefaultValue === "true"
        ) {
          setAnnRank(i.widgetRank);
        }
      });
    }
  }, [childWidget]);
  useEffect(() => {
    if (backendDataFormat) {
      setStartDate(
        moment()
          .subtract(1, "year")
          .format(backendDataFormat)
      );
      setEndDate(moment().format(backendDataFormat));
    }
  }, [backendDataFormat]);
  useEffect(() => {
    if (endDate && backendDataFormat) {
      setAnnouncementEndDate(
        moment(endDate)
          .add(1, "day")
          .format(backendDataFormat)
      );
    }
  }, [endDate]);
  let customerClass = useSelector(
    (state) => state?.meterDetails?.customerClassCd
  );

  const {t:labels, ready: labelReady}=useTranslation("label-E_ALERTS_AND_NOTIFICATION")

  let primaryIdentifier = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  let accountId = useSelector(
    (state) => state?.meterDetails?.accountId
  );
  let isPrepaidSa = useSelector(
    (store) => store?.meterDetails?.getSaInfo?.isPrepaidSa
  );
const ANNOUNCEMENT_VALUE="ANNOUNCEMENT"
  useEffect(() => {
    if (
      startDate &&
      endDate &&
      customerClass &&
      accountId &&
      labels &&
      announcementEndDate
    ) {
      setLoading(true);
      setMeterLoad(true)
      setData([]);
      meterAlertsCall(
        startDate,
        endDate,
        "",
        accountId,
        customerClass,
        announcementEndDate
      )
        .then((res) => {
          setLoading(false);
          setMeterLoad(false)
          setData((allData) => [
            ...allData,
            {
              title: labels("E_USER_THRESHOLD_ALERT_TAB_TITLE"),
              alertsData: res?.data?.getAlerts?.PrepaidBalanceThreshold,
              origin: "PrepaidBalanceThreshold",
              widgetRank: 0,
            },
            {
              title: labels("E_PREPAID_RECHARGE_ALERT_TAB_TITLE"),
              alertsData: res?.data?.getAlerts?.PrepaidRecharge,
              origin: "PrepaidRecharge",
              widgetRank: 0,
            },
          ]);
          {
            meterRank &&
              setData((allData) => [
                ...allData,
                {
                  title: labels("E_METER_ALERTS"),
                  alertsData: res?.data?.getAlerts?.Meter,
                  origin: "METER",
                  widgetRank: meterRank,
                },
              ]);
          }
          if (isPrepaidSa === "N") {
            {
              billRank &&
                setData((allData) => [
                  ...allData,
                  {
                    title: labels("E_BILL_NOTIFICATION"),
                    alertsData: res?.data?.getAlerts?.Bill,
                    origin: "BILL",
                    widgetRank: billRank,
                  },
                ]);
            }
          } else {
            {
              billRank &&
                setData((allData) => [
                  ...allData,
                  {
                    widgetRank: billRank,
                    origin: "PREPAID",
                    title: labels("E_PREPAID_TITLE"),
                    alertsData: [
                      {
                        title: labels("E_AMOUNT_CHANGES_TITLE"),
                        alertsData: res?.data?.getAlerts?.PrepaidAccountCharge,
                        origin: "CHARGE",
                        insideWidgetRank: chargeRank,
                      },
                      {
                        title: labels("E_LOW_BALANCE"),
                        alertsData: res?.data?.getAlerts?.PrepaidLowBalance,
                        origin: "LOWBALANCE",
                        insideWidgetRank: lowBalaceRank,
                      },
                      {
                        title: labels("E_BELOW_BALANCE"),
                        alertsData: res?.data?.getAlerts?.PrepaidMinimumBalance,
                        origin: "MINBALANCE",
                        insideWidgetRank: minBalanceRank,
                      },
                    ],
                  },
                ]);
            }
          }
        })
        .catch((err) => setLoading(false));
      setLoading(true);
      setAnnLoad(true)
      meterAlertsCall(
        startDate,
        endDate,
        ANNOUNCEMENT_VALUE,
        accountId,
        customerClass,
        announcementEndDate
      )
        .then((res) => {
          setLoading(false);
          setAnnLoad(false)
          {
            announceRank &&
              setData((allData) => [
                ...allData,
                {
                  title: labels("E_ANNOUNCEMENTS"),
                  alertsData: res?.data?.getAnnouncementList,
                  origin: "ANNOUNCEMENT",
                  widgetRank: announceRank,
                },
              ]);
          }
        })
        .catch((err) => setLoading(false));
    }
  }, [
    startDate,
    endDate,
    customerClass,
    accountId,
    labels,
    announcementEndDate,
    announceRank,
    meterRank,
    billRank,
    chargeRank,
    minBalanceRank,
    lowBalaceRank,
  ]);
  useEffect(() => {
    let tempAllData = []
    if(allData.length > 0) {      
      allData.forEach((item) => {
        let duplicate;
        tempAllData.forEach((ele) => {          
          if (item?.origin === ele?.origin) {
            duplicate = true
          }          
        })
        if(!duplicate) {
          tempAllData.push(item)
        }
    })
      setFinalData(tempAllData.sort((a, b) => a.widgetRank - b.widgetRank));
    }
  }, [allData]);

  return (
    <Grid container spacing={2}>
      {!loading && finalData ? (
        finalData.map((item,k) => (
          <Grid item xs={12} sm={12} lg={4} key={k}>
            <E_Alerts_Card
              title={item.title}
              data={item.alertsData}
              origin={item.origin}
              noContent={noContent}
              noContentContentReady={noContentContentReady}
              labelReady={labelReady}
              setAnnLoad={setAnnLoad}
              setMeterLoad={setMeterLoad}
              meterLoad={meterLoad}
              annLoad={annLoad}
            />
          </Grid>
        ))
      ) : (
        <>
          <Grid item sm={12} lg={4}>
            <Skeleton variant="rect" />
          </Grid>
          <Grid item sm={12} lg={4}>
            <Skeleton variant="rect" />
          </Grid>
          <Grid item sm={12} lg={4}>
            <Skeleton variant="rect" />
          </Grid>
        </>
      )}
    </Grid>
  );
}
